import { useCallback, useEffect, useState } from 'react';
import { DocumentsService } from '../../services/document/documentsService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage document status fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de estados de documentos.
----------------------------------------------------------------------------------------*/

const useDocuments = (isUser = false, initialFilters = {}) => {

    const [dataStatus, setDataStatus] = useState<any[]>([]);
    const [dataTypes, setDataTypes] = useState<any[]>([]);
    const [filters, setFilters] = useState({
        limit: 999999, 
        filter_filters: { ...initialFilters } 
    });

    const fetchDocumenStatus = useCallback(async () => {
        try {
            const service = new DocumentsService();
            const response = await service.listForSelectStatus({ limit: 999999 });
            const fetchedData = response.getResponseData().data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map(
                    (data: { 
                        id: string; 
                        name: string; 
                        color: string;
                    }) => ({
                    value: data.id,
                    label: data.name,
                    color: data.color,
                }));
                setDataStatus(mappedData);
            }
        } catch (error) {
            console.log('Error fetching documentsStatus:', error);
        }
    }, []);

    useEffect(() => {
        fetchDocumenStatus();
    }, []);

    const getDocumentStatusList = () => {
        return dataStatus;
    };

    const fetchDocumentTypes = useCallback(async (isUser: boolean) => {
        try {
            const service = new DocumentsService();
            const response = await service.listForSelectTypes({ limit: 999999 });
            const fetchedData = response.getResponseData().data;

            if (fetchedData && fetchedData?.data) {
                let mappedData = fetchedData.data?.map(
                    (data: { 
                        id: string; 
                        name: string; 
                     }) => ({
                    value: data.id,
                    label: data.name,
                }));
                setDataTypes(mappedData);
                if (!isUser) {
                    mappedData = mappedData.filter((item: any) => item.label !== "Documentos del usuario");
                }
                setDataTypes(mappedData);
            }
        } catch (error) {
            console.log('Error fetching documentTypes:', error);
        }
    }, []);

    useEffect(() => {
        fetchDocumentTypes(isUser);
    }, []);

    const getDocumentTypesList = () => {
        return dataTypes;
    };


    return { fetchDocumenStatus, getDocumentStatusList, fetchDocumentTypes, getDocumentTypesList };
}

export default useDocuments;